import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { checkShowBalanceApi } from './api';
import { CompanyEnabledFeatureKeyType, RoleType } from 'common/types/server-api-dtos';
import { useCustomizationStore } from '../customizations-service/service-store/service-store';
import { useShowBalanceStore } from './service-store/service-store';
import { CommonServiceApiTags } from '../api-tags';
import { userService } from 'common/utils/user-service';
import { ONE_MINUTE } from 'common/constants/common-time';
export var useShowBalanceData = function () {
    var companyEnabledFeatureKeys = useCustomizationStore(function (state) { return state.content.companyEnabledFeatureKeys; });
    var setPageContent = useShowBalanceStore(function (state) { return state.setPageContent; });
    var data = useQuery({
        queryKey: [CommonServiceApiTags.ShowBalance, companyEnabledFeatureKeys],
        enabled: (userService.hasRole(RoleType.Basic) &&
            companyEnabledFeatureKeys.includes(CompanyEnabledFeatureKeyType.AllowEmployeesToTransferCurrency)) ||
            (userService.hasRole(RoleType.Supervisor) &&
                companyEnabledFeatureKeys.includes(CompanyEnabledFeatureKeyType.AllowSupervisorsToTransferCurrency)),
        staleTime: ONE_MINUTE * 10,
        queryFn: function () {
            return checkShowBalanceApi();
        },
    }).data;
    if (data !== undefined) {
        setPageContent(data);
    }
};
export var useShowBalanceActions = function () {
    var setPageContent = useShowBalanceStore(function (state) { return state.setPageContent; });
    return useMemo(function () { return ({
        resetShowBalanceStateAction: function () {
            setPageContent([]);
        },
    }); }, [setPageContent]);
};
